import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useController } from 'react-hook-form';
import { MenuItem, TextField, Typography } from '@mui/material';
import { BannerBlock, BannerTextLineColor } from '../../../../declarations/models/blocks/BannerBlock';
import Container from '../../../../components/Container';
import { useCurrentBlock } from '../../CurrentBlockProvider';
import CheckboxInput from '../../../../components/forms/CheckboxInput';
import { BlockSpecificPage } from '../../../lib/declarations/BlockSpecificPage';

const TEXT_LINE_OPTIONS: Array<BannerTextLineColor> = [
  BannerTextLineColor.LIGHT_SEMI_TRANSPARENT,
  BannerTextLineColor.DARK_SEMI_TRANSPARENT,
];

export const BannerBlockTextEffects: FC = () => {
  const { blockPath, block } = useCurrentBlock();
  const currentBlock = block as BannerBlock;
  const { t } = useTranslation('components');
  const {
    field: { value: backgroundBox },
  } = useController<BlockSpecificPage<BannerBlock>, `${typeof blockPath}.useModuleContentBackgound`>({
    name: `${blockPath}.useModuleContentBackgound`,
  });
  const {
    field: { value: useTextbackgound },
  } = useController<BlockSpecificPage<BannerBlock>, `${typeof blockPath}.useTextbackgound`>({
    name: `${blockPath}.useTextbackgound`,
  });
  const {
    field: { value: textlineColor = BannerTextLineColor.DARK_SEMI_TRANSPARENT, onChange: onChangeTextlineColor },
  } = useController<BlockSpecificPage<BannerBlock>, `${typeof blockPath}.textlineColor`>({
    name: `${blockPath}.textlineColor`,
  });

  return (
    <Container
      fullWidth
      column
      p={2}
      mt={2}
      sx={{ alignItems: 'baseline !important', border: '2px solid #919191ff', borderRadius: 1 }}>
      <Typography>{t('BannerBlock.legacySettings')}</Typography>

      <Container fullWidth left pt={1} pb={1}>
        <CheckboxInput
          disabled={currentBlock.layout !== 'img' || (useTextbackgound && !(backgroundBox && useTextbackgound))}
          fullWidth={false}
          path={`${blockPath}.useModuleContentBackgound`}
          label={t('BannerBlock.useModuleContentBackgound')}
        />
      </Container>

      <Container fullWidth left>
        <CheckboxInput
          disabled={currentBlock.layout !== 'img' || (backgroundBox && !(backgroundBox && useTextbackgound))}
          fullWidth={false}
          path={`${blockPath}.useTextbackgound`}
          label={t('BannerBlock.useTextbackgound')}
        />
        {useTextbackgound && (
          <TextField
            value={textlineColor}
            onChange={onChangeTextlineColor}
            select
            label={t(`BannerBlock.BannerBlockTextLineColorSelector.label`)}
            sx={{ width: '300px' }}>
            {TEXT_LINE_OPTIONS.map((option) => {
              return (
                <MenuItem key={option} value={option}>
                  {option ? t(`BannerBlock.BannerBlockTextLineColorSelector.${option}`) : ''}
                </MenuItem>
              );
            })}
          </TextField>
        )}
      </Container>
    </Container>
  );
};

export default BannerBlockTextEffects;
